<template>
  <div>
    <div class="filter-wrapper filter-wrapper-tab">
      <CallsLink />
      <div class="link-filter-wrapper">
        <div>
          <v-select
            v-model="dataSelectTeamsValue"
            :options="dataSelectOptionsTeam"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Teams"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectTeamsValue ? 'call-select--value' : null
            ]"
            @input="() => {getTeam(); $_ajax({ reset: true })}">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px;"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <v-select
            v-if="dataSelectTeamsValue"
            v-model="timeZoneOffset"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            :class="[
              'call-select',
              dataSelectTeamsValue ? 'call-select--value' : null
            ]"
            :options="computedOffsetList"
            :filterable="false"
            :searchable="false"
            :clearable="false"
            striped
            @input="() =>{}">
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
          </v-select>
        </div>

        <div>
          <call-pagination
            page-calc
            :page-value="50"
            :obj-pagination="dataObjPagination"
            @on-pagination="$_ajax" />
        </div>
      </div>
    </div>
    <div style="display: flex;">
      <div
        class="table-wrapper"
        style="flex-grow: 1">
        <b-table
          :show-empty="isLoaded"
          striped
          hover

          :tbody-tr-class="onRowClass"
          no-local-sorting
          :fields="dataMixinCallsFields"
          :items="dataCallsList"
          @row-clicked="value => onRecords(value, 'view')"
          @sort-changed="onSortTabel">
          <template #empty>
            <EmptyTable />
          </template>
          <template #cell(teams)="data">
            {{ data.item.teams | joinName }}
          </template>
          <template #cell(calls)="data">
            {{ data.item.records.length || 0 }}
          </template>
        </b-table>
      </div>

      <div class="recoridng-wrapper">
        <CallCallList
          :obj-event="dataRecords"
          :tz="timeZoneOffset" />
      </div>
    </div>
  </div>
</template>

<script>
import CallsLink from './components/CallsLink.vue';

import { BTable } from 'bootstrap-vue';
import {
  CALL_GET_USERS,
  TEAMS_GET_ALL,
  TEAMS_GET
} from '../../../store/types/actions.types';
import selectAllTeams from '../../../mixins/select/selectAllTeams';
import CallPagination from '../../../components/desktop/CallPagination';
import helper from '../../../service/helper';
import selectOperators from '@/mixins/select/selectOperators';
import callsTable from '@/mixins/table/callsTable';
import CallCallList from '@/components/desktop/recording/CallCallList';
import { mapGetters } from 'vuex';
import { faPowerOff } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'PageCalls',
  components: {
    CallCallList,
    CallPagination,
    BTable,
    CallsLink
  },
  mixins: [callsTable, selectAllTeams, selectOperators],
  data () {
    return {
      isLoaded: false,
      dataIconLock: faPowerOff,
      dataCallsList: [],
      dataDesc: null,
      dataOrderBy: null,
      dataObjPagination: {},
      dataRecords: {},
      dataSelectOptionsTeam: [],
      timeZoneOffset: null,
      computedOffsetList: []
    };
  },
  computed: {
    ...mapGetters({
      computedIsOperator: 'auth/isOperator',
      computedIsModerator: 'auth/isModerator',
      computedCurrentUser: 'auth/currentUser',
      computedIsAdmin: 'auth/isAdmin'
    }),
    isSelectedTeamFilter () {
      return !!this.dataSelectTeamsValue;
    }
  },

  watch: {
    dataSelectTeamsValue (value) {
      if (!value) {
        this.timeZoneOffset = null;
      }
    }
  },
  async created () {
    this.isLoaded = false;
    this.$_ajax = ((options = {}) => {
      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'role',
            'search',
            'teamId',
            'desc',
            'orderBy',
            'limit',
            'page'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'role':
                  this.dataSelectRoleValue = options[_key];
                  break;
                case 'search':
                  this.dataSearch = options[_key];
                  break;
                case 'teamId':
                  this.dataSelectTeamsValue = options[_key];
                  break;
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        role = this.dataSelectRoleValue,
        search = this.dataSearch,
        teamId = this.dataSelectTeamsValue,
        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        limit = null,
        page = null,
        reset = false
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          if (teamId) {
            this.getTeam();
          }

          const {
            payload: { list = [] },
            misc: { paging = {} }
          } = await this.$store.dispatch(`call/${CALL_GET_USERS}`, {
            params: {
              role: role?.value,
              search,
              team_ids: [teamId?.id],
              desc,
              order_by: orderBy,
              limit: _limit,
              page: _page
            }
          });
          this.dataObjPagination = paging;
          this.dataCallsList = list.map(item => {
            item.actions = false;
            return item;
          });

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    role,
                    search,
                    teamId,
                    desc,
                    orderBy,
                    limit: _limit,
                    page: _page
                  })
                )
              }
            })
            .catch(() => {});

          this.dataRecords = helper.getOneArray(this.dataCallsList);
          this.isLoaded = true;
          options = {};
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      const [
        {
          payload: { list: listTeam = [] }
        }
      ] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true
          }
        }),
        this.$_ajax()
      ]);

      this.dataSelectOptionsTeam = listTeam.sort(
        (a, b) => b.is_active - a.is_active
      );
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },
  methods: {
    async getTeam () {
      if (!this.dataSelectTeamsValue) return;
      // if (this.firstLoad) {
      const { team = {} } = await this.$store.dispatch(`team/${TEAMS_GET}`, {
        params: {
          id: this.dataSelectTeamsValue.id
        }
      });
      this.timeZoneOffset = this.$store.state.team.utc.find(
        item => item.id === team.timezone_offset
      );
      if (team.timezone_offset === 0) {
        this.computedOffsetList = [
          {
            id: 0,
            name: this.$store.state.team.utc.find(item => item.id === 0).name
          }
        ];
      } else {
        this.computedOffsetList = [
          {
            id: this.timeZoneOffset.id,
            name: this.$store.state.team.utc.find(
              item => item.id === this.timeZoneOffset.id
            ).name

          },
          {
            id: 0,
            name: this.$store.state.team.utc.find(item => item.id === 0).name
          }
        ];
      }
      // this.firstLoad = false;
      // }
    },
    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    },
    onRecords (data) {
      this.dataRecords = data;
    },
    onRowClass (item, type) {
      if (!item || type !== 'row') return;
      if (item.id === this.dataRecords.id) return 'table-success';
    }
  }
};
</script>

<style lang="sass" scoped>
.home
  display: flex
.recoridng-wrapper
  flex: 0 0 265px
  margin-left: 33px
</style>
